<template>
    <div class="page">
        <div class="fill50"></div>
        <div class="topBox" v-if="false">
            <div class="topTitle">PRODUCTS</div>
            <!-- <div class="topTitle2">产品</div> -->
            <div class="line"></div>
        </div>
        <div class="topBox2" v-if="false">
            <el-carousel trigger="click" height="400px">
                <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                    <el-image class="img" :src="item.image" fit="cover"></el-image>
                </el-carousel-item>
            </el-carousel>
        </div>
        <pageBreadcrumb :option="nav_option" />
        <div class="listBox" v-if="list.length > 0">
            <div class="wrap">
                <div class="listFlexBox">
                    <div class="itemBox" v-for="(item, index) in list" :key="item.id" @click="goNext(item)">
                        <div class="imgBox">
                            <el-image class="img" :src="item.thumb" fit="cover"></el-image>
                            <img src="@/assets/img/productList/selectProductBg.png" class="selectProductBg" alt="" />
                        </div>
                        <div class="proTitle">{{ lang == 'en' ? item.enTitle : item.title }}</div>
                        <!-- <div class="proTitle" v-if="item.subtitle">{{ item.subtitle }}</div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="wrap" v-if="list.length > 0">
            <el-pagination
                class="elpagination"
                background
                layout="prev, pager, next"
                :total="count"
                :current-page="page"
                :page-size="pageNum"
                @current-change="changePage"
            >
            </el-pagination>
        </div> -->
        <el-empty v-if="list.length == 0" description="暂无数据..."></el-empty>
        <div class="fill100"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'
let that
export default {
    name: 'productListFirst',
    components: {
        pageBreadcrumb,
    },
    data() {
        return {
            nav_option: [
                { title: '首页', path: '/' },
                { title: '产品', path: '' },
            ],
            id: '',
            keyword: '',
            count: 0,
            page: 1,
            pageNum: 99999,
            list: [],
            bannerList: [],

            parentIdList: [], // 顶级分类id
        }
    },
    computed: {
        ...mapState([]),
    },
    watch: {
        $route: {
            immediate: false,
            deep: true,
            handler() {
                this.init()
                // location.reload()
            },
        },
    },
    created() {
        that = this
        this.nav_optionInit()
        that.init()
    },
    mounted() {},
    methods: {
        nav_optionInit() {
            this.nav_option = [
                { title: this.$t('首页'), path: '/' },
                { title: this.$t('产品'), path: '' },
            ]
        },
        async getBanner() {
            let res = await this.bannerIndexAjax()
            if (res.code == 200) {
                let list = res.data
                let arrList = []
                for (let i = 0; i < list.length; i++) {
                    let item = list[i]
                    if (item.id == 177) {
                        arrList = item.images
                    }
                }
                this.bannerList = arrList
            }
        },
        async init() {
            that.id = that.$route.query.id
            that.keyword = that.$route.query.keyword

            // 获取所有顶级分类的id
            let res = await this.productChannelAjax()
            if (res) {
                this.parentIdList = []
                res.data.forEach((item, index) => {
                    this.parentIdList.push(item.id)
                })
            }

            // 首页搜索进入
            if (that.keyword && that.id && that.$route.query.title) {
                that.nav_option = [
                    { title: this.$t('首页'), path: '/' },
                    { title: this.$t('搜索'), path: '/' },
                    // { title: that.$route.query.title, path: '' },
                    { title: that.keyword, path: '' },
                ]
                that.getPList(that.keyword)
                return
            }

            // header搜索进入
            if (that.keyword) {
                that.nav_option = [
                    { title: this.$t('首页'), path: '/' },
                    { title: this.$t('搜索'), path: '' },
                    { title: that.keyword, path: '' },
                ]
                that.getPList(that.keyword)
                return
            }

            if (that.$route.query.title && that.$route.query.titleParent) {
                that.nav_option = [
                    { title: this.$t('首页'), path: '/' },
                    { title: this.$t('产品'), path: '/productListFirst' },
                    { title: that.$route.query.titleParent, path: '' },
                    { title: that.$route.query.title, path: '' },
                ]
            } else if (that.$route.query.title && !that.$route.query.titleParent) {
                that.nav_option = [
                    { title: this.$t('首页'), path: '/' },
                    { title: this.$t('产品'), path: '/productListFirst' },
                    { title: that.$route.query.title, path: '' },
                ]
            } else {
                that.nav_option = [
                    { title: this.$t('首页'), path: '/' },
                    { title: this.$t('产品'), path: '/productListFirst' },
                ]
            }

            if (!this.id) {
                that.getChannelList()
            } else if (this.id && this.parentIdList.includes(Number(this.id))) {
                that.getChannelList({
                    parentId: this.id,
                })
            } else {
                that.getPList()
            }
        },
        goNext(item) {
            if (this.keyword) {
                // 通过搜索进入，去商品详情
                this.$router.push({
                    path: '/product-detail',
                    query: {
                        id: item.inventoryId,
                    },
                })
            } else if (this.id && this.parentIdList.includes(Number(this.id))) {
                // 点击 军鼓、硬件、配件 ，更新列表
                this.$router.push({
                    path: '/productListFirst',
                    query: {
                        id: item.id,
                        title: this.lang == 'en' ? item.enTitle : item.title,
                        titleParent: this.$route.query.title,
                    },
                })
            } else if (this.id) {
                // 有id，去详情
                this.$router.push({
                    path: '/product-detail',
                    query: {
                        id: item.inventoryId,
                    },
                })
            } else {
                // 更新列表
                this.$router.push({
                    path: '/productListFirst',
                    query: {
                        id: item.id,
                        title: this.lang == 'en' ? item.enTitle : item.title,
                    },
                })
            }
        },
        goSecondPage(item) {
            let { channels, parentId } = item
            if (channels.length > 0) {
                // 有子集，去first
                this.$router.push({
                    path: '/productListFirst',
                    query: {
                        id: item.id,
                        title: item.title,
                    },
                })
            } else if (channels.length == 0) {
                // 无子集
                if (parentId == 0) {
                    this.$router.push({
                        path: '/productListSecond',
                        query: {
                            id: item.id,
                            title: item.title,
                        },
                    })
                } else {
                    this.$router.push({
                        path: '/productListSecond',
                        query: {
                            id: item.id,
                            title: that.$route.query.title,
                            title2: item.title,
                        },
                    })
                }
            }
        },
        async getChannelList(obj = {}) {
            // this.$load.open()
            let res = await this.productChannelAjax(obj)
            // this.$load.close()
            if (res) {
                if (res.code == 200) {
                    if (this.isArray(res.data)) {
                        this.list = res.data
                    }
                }
            }
        },
        async getPList(keyword = '') {
            let obj = {
                channelId: this.id,
                page: this.page,
                pageNum: this.pageNum,
                keyword: keyword,
            }
            // this.$load.open()
            let res = await this.productPlistAjax(obj)
            // this.$load.close()
            if (res) {
                if (res.code == 200) {
                    if (this.isArray(res.data.list)) {
                        this.list = res.data.list
                        this.count = res.data.count
                        if (this.list.length > 0 && this.list[0] && this.list[0].channel_id_up && !this.keyword) {
                            that.nav_option = [
                                { title: this.$t('首页'), path: '/' },
                                { title: this.$t('产品'), path: '/productListFirst' },
                                {
                                    title: that.$route.query.titleParent,
                                    path: `/productListFirst?id=${this.list[0].channel_id_up}&title=${this.list[0].channel_title_up}`,
                                },
                                { title: that.$route.query.title, path: '' },
                            ]
                        }
                    }
                }
            }
        },
        isArray(arg) {
            if (typeof Array.isArray === 'undefined') {
                return Object.prototype.toString.call(arg) === '[object Array]'
            }
            return Array.isArray(arg)
        },
        productPlistAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'product_plist',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        bannerIndexAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'banner_index',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        productChannelAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'product_channel',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        changePage(index) {
            this.page = index
            this.getPList()
        },
    },
}
</script>

<style scoped lang="less">
.topBox2 {
    width: 100%;
    height: 400px;
    overflow: hidden;
    margin-bottom: 50px;

    .img {
        width: 100%;
        height: 100%;
    }
}

.topBox {
    width: 100%;
    height: 400px;
    background: url('../../assets/img/productList/topBg.png') no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    margin-bottom: 50px;

    .topTitle {
        width: 100%;
        text-align: center;
        margin-top: 100px;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        font-family: 'myTextStyle';
        margin-bottom: 100px;
    }

    .topTitle2 {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        margin-bottom: 110px;
    }

    .line {
        width: 155px;
        height: 3px;
        background: #ffffff;
        margin: 0 auto;
    }
}

.wrap {
    width: @width;
    overflow: hidden;
    margin: 0 auto;
}

.listBox {
    width: 100%;
    margin-top: 50px;

    .listFlexBox {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;

        .itemBox {
            width: 20%;
            margin-right: 6.4%;
            margin-top: 20px;
            cursor: pointer;

            &:nth-child(-n + 4) {
                margin-top: 0;
            }

            .proTitle {
                width: 100%;
                font-size: 14px;
                color: #000000;
                line-height: 24px;
                height: auto;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                text-align: center;
            }

            &:nth-child(4n) {
                margin-right: 0;
            }

            .imgBox {
                width: 100%;
                height: 250px;
                position: relative;
                margin-bottom: 15px;

                .img {
                    width: 100%;
                    height: 250px;
                    position: relative;
                }

                .selectProductBg {
                    display: none;
                    width: 100%;
                    height: 250px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }

            &:hover {
                .selectProductBg {
                    display: block;
                }

                .proTitle {
                    color: #ff4d00;
                }
            }
        }
    }
}

.elpagination {
    text-align: end;
}

.fill50 {
    width: 100%;
    height: 50px;
}

.fill100 {
    width: 100%;
    height: 100px;
}
</style>
<style scoped lang="less" src="@/assets/h5css/mobile/productListFirst.less"></style>
